module.exports = __webpack_public_path__ + "static/media/img_12.f3ca7c85.png";